import { Activity } from "lucide-react";

const ACTION_LABELS = {
  login_success: "Connexion",
  login_failed: "Échec connexion",
  password_changed: "Mot de passe modifié",
  mfa_enabled: "MFA activée",
  mfa_disabled: "MFA désactivée",
  recovery_code_used: "Code de secours",
  recovery_codes_regenerated: "Codes régénérés",
  user_deleted: "Utilisateur supprimé",
  role_changed: "Rôle modifié",
  sessions_revoked: "Sessions révoquées",
  logout_all: "Déconnexion partout",
  favorites_shared: "Favoris partagés",
  favorites_share_revoked: "Partage révoqué",
  review_saved: "Avis publié",
  review_deleted: "Avis supprimé",
};

const ACTION_TONE = {
  login_success: "bg-emerald-950/60 text-emerald-400",
  login_failed: "bg-red-950/60 text-red-400",
  user_deleted: "bg-red-950/60 text-red-400",
  review_deleted: "bg-red-950/60 text-red-400",
  role_changed: "bg-violet-950/60 text-violet-400",
  mfa_enabled: "bg-sky-950/60 text-sky-400",
  mfa_disabled: "bg-amber-950/60 text-amber-400",
};

export function AdminActivity({ items }) {
  return (
    <div className="mt-8 overflow-hidden rounded-xl border border-[#1E2638] bg-[#0F141C]">
      <div className="flex items-center gap-2 border-b border-[#1E2638] px-5 py-3">
        <Activity className="h-4 w-4 text-primary" />
        <h2 className="font-head text-base font-bold">Journal d'activité</h2>
      </div>
      <ul data-testid="admin-activity-list" className="divide-y divide-[#1E2638]/60">
        {items.length === 0 ? (
          <li className="px-5 py-4 text-sm text-muted-foreground">Aucune activité enregistrée.</li>
        ) : items.map((a) => (
          <li key={`${a.ts}-${a.actor}-${a.action}-${a.detail || ""}`} className="flex flex-wrap items-center justify-between gap-2 px-5 py-2.5 text-sm">
            <span className="flex items-center gap-2">
              <span className={`rounded px-2 py-0.5 font-mono2 text-[10px] uppercase ${ACTION_TONE[a.action] || "bg-slate-800 text-slate-400"}`}>
                {ACTION_LABELS[a.action] || a.action}
              </span>
              <span className="font-mono2 text-xs text-slate-300">{a.actor}</span>
              {a.detail && <span className="text-xs text-muted-foreground">· {a.detail}</span>}
            </span>
            <span className="font-mono2 text-[11px] text-muted-foreground">{new Date(a.ts).toLocaleString("fr-FR")}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
